/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BaseCellDTO } from './baseCellDTO';
import { GeoTestRegionsLocationDTO } from './geoTestRegionsLocationDTO';
import { BaseMetricDTO } from './baseMetricDTO';


export interface GeoTestRegionsCellDTO { 
    id: number;
    cellName: BaseCellDTO;
    cellSize: BaseMetricDTO;
    cellRank: number;
    locations: Array<GeoTestRegionsLocationDTO>;
    anchorLocations: Array<GeoTestRegionsLocationDTO>;
    geoScopeIds: Array<number>;
    geoSplitType: GeoTestRegionsCellDTO.GeoSplitTypeEnum;
    nextAvailableDate?: BaseMetricDTO;
}
export namespace GeoTestRegionsCellDTO {
    export type GeoSplitTypeEnum = 'CITY' | 'REGION' | 'COUNTRY' | 'DMA' | 'ZIP';
    export const GeoSplitTypeEnum = {
        City: 'CITY' as GeoSplitTypeEnum,
        Region: 'REGION' as GeoSplitTypeEnum,
        Country: 'COUNTRY' as GeoSplitTypeEnum,
        Dma: 'DMA' as GeoSplitTypeEnum,
        Zip: 'ZIP' as GeoSplitTypeEnum
    };
}


